import React from 'react';

function NoAccess() {
  return (
    <div className="page-container">
      <div className="alert alert-warning" role="alert">
        <h4 className="alert-heading">Access Denied</h4>
        <p className="mb-0">Your account does not have access to any application pages. Contact your administrator.</p>
      </div>
    </div>
  );
}

export default NoAccess;
